// extracted by mini-css-extract-plugin
module.exports = {"cellCenter":"Table_cellCenter__1yFxH","hide":"Table_hide__2vBVF"};